import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import React, {Children, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {Organization} from "../../models/organization";

const useStyles = makeStyles(theme => ({
    actionRow: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            justifyContent: 'flex-end'
        },
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center'
        },
    },
    search: {
        [theme.breakpoints.up('md')]: {
            position: 'absolute',
            top: '60px',
            left: '47%'
        }
    },
    root: {
        position: 'relative',
    },
}));

interface CrossOrganizationSearchArg {
    organization: Organization | undefined;
    children: any;
}

const CrossOrganizationSearchAction = ({children}: { children: any }) => <> {children}</>
const CrossOrganizationSearchBody = ({children}: { children: any }) => <>{children}</>

export const CrossOrganizationSearch = ({organization, children}: CrossOrganizationSearchArg) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const [onlyInOrganization, setOnlyInOrganization] = useState<boolean>(!!organization)
    let _body, _action

    Children.forEach(children, child => {
        if (child.type === CrossOrganizationSearchAction) {
            return _action = <div title={onlyInOrganization ? undefined : t('Members.MoveMembers.DisabledTooltip')}>
                {React.cloneElement(child.props.children, {
                    disabled: !onlyInOrganization,
                })}
            </div>
        }

        if (child.type === CrossOrganizationSearchBody) {
            return _body = React.cloneElement(child.props.children, {organizationId: onlyInOrganization ? organization?.id : undefined})
        }
    });

    return (
        <Grid container className={classes.root}>
            <Grid container item xs={12} className={classes.actionRow}>
                {_action}
            </Grid>
            <Box component={Grid} visibility={organization ? "visible" : "hidden"} className={classes.search}>
                <FormControlLabel control={<Checkbox checked={onlyInOrganization}
                                                     onChange={() => setOnlyInOrganization((prev) => !prev)}
                                                     color="primary"
                                                     name="searchOnlyInOrganization"/>}
                                  label={t('Machine.SearchOnlyIn', {organizationName: organization?.name})}/>
            </Box>
            {_body}
        </Grid>
    );
}

CrossOrganizationSearch.Action = CrossOrganizationSearchAction;
CrossOrganizationSearch.Body = CrossOrganizationSearchBody;
